import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Card, CardBody, Form, Row, Col, Input, Button, FormGroup, InputGroupAddon, InputGroupText, InputGroup, Spinner } from "reactstrap";

// style
import "assets/css/loading.css";

// services
import { showMessage } from "utils/message.js";
import { getSessionCookie } from "utils/cookies";

// api
import usuario_api from "api/usuario_api.js";

export default function TrocarSenha({ history }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);
    
    const onSubmit = (data) => {  
        if (data.novaSenha.length < 5){
          showMessage("Aviso", "Informe uma senha com no mínimo 5 dígitos", 'error', null); 
          return;
        }
    
        if (data.novaSenha != data.confirmarSenha){
          showMessage("Aviso", "A Nova Senha e a Confirmação da Nova Senha estão diferentes", 'error', null); 
          return;
        }
        
        let json_submit = {
          usuario_Id: session.usuario_Id,
          senhaAntiga: data.senhaAntiga,
          novaSenha: data.novaSenha
        }
        
        setshowLoading(true);
        usuario_api.trocar_senha(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }           
            else {
                showMessage("Aviso", "Operação realizada com sucesso!", 'success', function(){
                    history.push("/admin/inicio");
                });
            }
        });          
    }

  return (
    <>
    {showLoading && 
          <div className="carregandoCmp">
              <div className="box">                
                <Spinner></Spinner>
              </div>
          </div> 
        }
      <div className="content">                
          <Row>
            <Col md="12">
              <Card className="card-user">
                <CardBody style={{ minHeight: "auto" }}>
                  <Form style={{maxWidth:"95%",margin:"0 auto"}} onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <label>Senha Antiga</label>
                                <br/>
                                <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                    <i className="fas fa-key" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="password" name="senhaAntiga" innerRef={register({ required: true })}/>
                                </InputGroup>
                                {errors.senhaAntiga && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label>Nova Senha</label>
                                <br/>
                                <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                    <i className="fas fa-key" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="password" name="novaSenha" innerRef={register({ required: true })}/>
                                </InputGroup>
                                {errors.novaSenha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label>Confirmar Senha</label>
                                <br/>
                                <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                    <i className="fas fa-key" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="password" name="confirmarSenha" innerRef={register({ required: true })}/>
                                </InputGroup>
                                {errors.confirmarSenha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>                      
                    </Row>
                    <Row className="text-center">
                        <Col md="12">                            
                            <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i> Salvar</Button>                            
                        </Col>
                    </Row> 
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>        
      </div>
    </>
  );
}